"use client"
import { useAppContext } from "../context/AppContext"
import "./ShiftList.css"

const ShiftList = ({ shifts, onEditShift }) => {
  const { tags } = useAppContext()

  const getTag = (tagId) => {
    return tags.find((tag) => tag.id === tagId) || null
  }

  return (
    <div className="shift-list">
      {shifts.map((shift) => {
        const tag = getTag(shift.tagId)
        if (!tag) return null

        return (
          <div key={shift.id} className="shift-item" onClick={() => onEditShift(shift)}>
            <div className="shift-color" style={{ backgroundColor: tag.color }}></div>

            <div className="shift-details">
              <div className="shift-name">{tag.name}</div>
              <div className="shift-time">
                {shift.time ? <>
                  {shift.startTime} - {shift.endTime}
                </> : <>Horario não informado</>}
              </div>
            </div>

            <div className="shift-info">
              <div className={`shift-status ${shift.paid ? "paid" : "pending"}`}>
                {shift.paid ? "Pago" : "Pendente"}
              </div>
              <div className="shift-amount">R$ {shift.value ? shift.value.toFixed(2) : tag.paymentAmount.toFixed(2)}</div>
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default ShiftList

